import { render, staticRenderFns } from "./DestinationModal.vue?vue&type=template&id=32ced494&scoped=true"
import script from "./DestinationModal.vue?vue&type=script&lang=js"
export * from "./DestinationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ced494",
  null
  
)

export default component.exports